import { useLeadActionAutomations } from '@/models/leadActionAutomation'
import { LeadActionRunItem } from './LeadActionRunItem'

interface LeadActionAutomationRunsProps {
  /** Filter the leads list to a verdict tag, e.g. every lead a GEICO run found eligible. */
  onFilterByTag: (tagId: string) => void
}

/** The rep's recent action runs with live progress, so a long run can be watched or stopped. */
export function LeadActionAutomationRuns({ onFilterByTag }: LeadActionAutomationRunsProps) {
  const { data: runs } = useLeadActionAutomations()
  if (!runs?.length) return null

  return (
    <div className="flex flex-col gap-2 border-t pt-3">
      <div className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Recent runs</div>
      <ul className="flex max-h-60 flex-col gap-2.5 overflow-x-hidden overflow-y-auto pr-1">
        {runs.map((run) => (
          <LeadActionRunItem key={run.id} run={run} onFilterByTag={onFilterByTag} />
        ))}
      </ul>
    </div>
  )
}
